//@mui
import { Stack } from '@mui/system';
//reducers
//components
import { FormGroup } from '@mui/material';
import { BankAccount } from 'constants/bank-account.constants';
import BankAccountDetails from './BankAccountDetails';
//constants

interface BankAccountsProps {
	accounts: BankAccount[];
	handleBankPick: any;
	selectedAccountId: number | null;
}

export default function BankAccountsDetails(props: BankAccountsProps) {
	const handleBankChoose = (id: number) => {
		props.handleBankPick(id);
	};
	return (
		<Stack>
			<FormGroup sx={{ rowGap: '8px' }}>
				<Stack spacing={1}>
					{props.accounts.map((account) => {
						return (
							<BankAccountDetails
								key={`bank-account-${account.id}`}
								account={account}
								isSelected={props.selectedAccountId === account.id}
								handleBankPick={handleBankChoose}
							/>
						);
					})}
				</Stack>
			</FormGroup>
		</Stack>
	);
}
